let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jUMMO")).then(() => parcelRequire('9jC9P'));